import type { Locale, LocalizedString } from "@core/schema/Locale.js";
import { translate } from "@core/utils/translate.js";
import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";

export function getTranslate<Translations extends Record<string, LocalizedString>>(
	translations: Translations,
	locale = getGlobalTemplateProps().tenant.locale,
) {
	return <Key extends keyof Translations>(
		key: Key,
		variables: Record<string, string | number> = {},
	): Translations[Key][Locale] => {
		return translate<Translations, Key>(translations, key, locale, variables);
	};
}
